import request from "@/utils/requestSC";

// 获取拼团列表
export async function queryGoodsList(params) {
  return request.post("rest/yx/groupActivity/goodsList", params);
}

// 获取我的拼团列表
export async function queryMyGroupList(params) {
  return request.post("rest/yx/group/list", params);
}

// 获取拼团详情
export async function queryGroupDetail(params) {
  // return request.post('/rest/yx/group/detail', params);
  return request({
    url: "/rest/yx/group/detail",
    method: "post",
    params
  });
}

// 获取进行中的拼团
export async function queryInHandGroupList(params) {
  // return request.post('/rest/yx/group/detail', params);
  return request({
    url: "/rest/yx/group/getInHandGroupList",
    method: "post",
    params
  });
}

// 获取我的拼团--团员
export async function getMyInHandGroupList(params) {
  // return request.post('/rest/yx/group/detail', params);
  return request({
    url: "/rest/yx/group/getMyInHandGroupList",
    method: "post",
    params
  });
}

// 校验活动是否结束
export async function getVerifyGroupStatus(params) {
  // return request.post('/rest/yx/group/detail', params);
  return request({
    url: "/rest/yx/group/getVerifyGroupStatus",
    method: "post",
    params
  });
}

// 校验是否允许开团
export async function getVerifySponsorGroup(params) {
  // return request.post('/rest/yx/group/detail', params);
  return request({
    url: "/rest/yx/group/getVerifySponsorGroup",
    method: "post",
    params
  });
}

// 校验是否允许参团
export async function getVerifyJoinGroup(params) {
  // return request.post('/rest/yx/group/detail', params);
  return request({
    url: "/rest/yx/group/getVerifyJoinGroup",
    method: "post",
    params
  });
}
